import { IconContainer, ItemRotation } from "@src/components/helper.styled";

export const GitIcon = () => {
    return (
        <ItemRotation>
            <IconContainer>
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.5 12.25C11.4665 12.25 12.25 11.4665 12.25 10.5C12.25 9.5335 11.4665 8.75 10.5 8.75C9.5335 8.75 8.75 9.5335 8.75 10.5C8.75 11.4665 9.5335 12.25 10.5 12.25Z" stroke="#111113" stroke-width="0.833333" strokeLinecap="round" stroke-linejoin="round" />
                    <path d="M3.5 5.25C4.4665 5.25 5.25 4.4665 5.25 3.5C5.25 2.5335 4.4665 1.75 3.5 1.75C2.5335 1.75 1.75 2.5335 1.75 3.5C1.75 4.4665 2.5335 5.25 3.5 5.25Z" stroke="#111113" stroke-width="0.833333" strokeLinecap="round" stroke-linejoin="round" />
                    <path d="M7.5835 3.5H9.3335C9.64292 3.5 9.93966 3.62292 10.1585 3.84171C10.3772 4.0605 10.5002 4.35725 10.5002 4.66667V8.75" stroke="#111113" stroke-width="0.833333" strokeLinecap="round" stroke-linejoin="round" />
                    <path d="M3.5 5.25V12.25" stroke="#111113" stroke-width="0.833333" strokeLinecap="round" stroke-linejoin="round" />
                </svg>
            </IconContainer>
        </ItemRotation>
    );
};
